export function invariant(check, message, thing) {
  if (!check) {
    throw new Error("[designer] Invariant failed: " + message + (thing ? " in '" + thing + "'" : ''));
  }
}